import React from "react";
import { Link } from "react-router-dom";

import {
  Collapse,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  NavbarBrand,
  Navbar,
  /* NavItem,
  NavLink, */
  Nav,
  Container,
  Row,
  Col,
} from "reactstrap";

function NavbarPrimary() {
  const style = { width: "75%", height: "75%" }
  const [collapseOpen, toggleCollapseOpen] = React.useState(false);
  return (
    <Navbar className="navbar-dark bg-default" expand="lg">
      <Container>
        <NavbarBrand className="float-left col-3" to="/" tag={Link}>
          <img
            style={ style }
            alt="..."
            src={require("assets/img/brand/blue.png")}
          ></img>
        </NavbarBrand>
        <button
          className="navbar-toggler float-right"
          onClick={() => toggleCollapseOpen(!collapseOpen)}
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <Collapse isOpen={collapseOpen} navbar>
          <div className="navbar-collapse-header">
            <Row>
              <Col className="collapse-brand float-left" xs="6">
                <Link to="/">
                  <img
                    alt="..."
                    src={require("assets/img/brand/blue.png")}
                    style={ style }
                  ></img>
                </Link>
              </Col>
              <Col className="collapse-close" xs="6">
                <button
                  className="navbar-toggler"
                  onClick={() => toggleCollapseOpen(!collapseOpen)}
                >
                  <span></span>
                  <span></span>
                </button>
              </Col>
            </Row>
          </div>
          <Nav className="ml-lg-auto" navbar>
            {/* <NavItem>
              <NavLink href="/solutions" onClick={SubmitEvent}>
                <i className="ni ni-planet img-fluid d-inline"></i>
                Solutions <span className="sr-only">(current)</span>
              </NavLink>
            </NavItem> */}
            <UncontrolledDropdown nav>
              <DropdownToggle
                aria-expanded={false}
                aria-haspopup={true}
                caret
                color="default"
                data-toggle="dropdown"
                href="#pablo"
                onClick={(e) => e.preventDefault()}
                id="navbar-primary_dropdown_1"
                nav
                name="button"
              >
                More
              </DropdownToggle>
              <DropdownMenu aria-labelledby="navbar-primary_dropdown_1" right>
                {/* <DropdownItem
                  href="/about-us"
                  onClick={SubmitEvent}
                >
                  About Us
                </DropdownItem> */}
                <DropdownItem
                  href="/home#prefooter"
                  onClick={SubmitEvent}
                >
                  Contact Us
                </DropdownItem>
                <DropdownItem divider></DropdownItem>
                <DropdownItem
                  href="/faqs"
                  onClick={SubmitEvent}
                >
                  FAQs
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>
        </Collapse>
      </Container>
    </Navbar>
  );
}

export default NavbarPrimary;
